// File: frontend/src/pages/SuperAdmin/components/UserManagement/index.js

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
import UserList from './UserList';
import UserDetail from './UserDetail';
import UserVerification from './UserVerification';
import styles from './UserManagement.module.css';

const UserManagement = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [view, setView] = useState('list');
  const [userId, setUserId] = useState(null);
  
  useEffect(() => {
    const path = location.pathname;
    
    if (path === '/super-admin-panel/users') {
      setView('list');
    } else if (path === '/super-admin-panel/users/verification') {
      setView('verification');
    } else if (path.match(/\/super-admin-panel\/users\/[^/]+$/)) {
      const id = path.split('/').pop();
      setUserId(id);
      setView('detail');
    }
  }, [location.pathname]);
  
  const handleViewUser = (id) => {
    navigate(`/super-admin-panel/users/${id}`);
  };
  
  const handleViewVerification = () => {
    navigate('/super-admin-panel/users/verification');
  };
  
  const handleBackToList = () => {
    navigate('/super-admin-panel/users');
  };
  
  // Render the appropriate view
  const renderView = () => {
    switch (view) {
      case 'detail':
        return (
          <UserDetail 
            userId={userId} 
            onBack={handleBackToList}
          />
        );
      case 'verification':
        return (
          <UserVerification 
            onBack={handleBackToList}
            onViewUser={handleViewUser}
          />
        );
      default:
        return (
          <UserList 
            onViewDetail={handleViewUser}
            onViewVerification={handleViewVerification}
          />
        );
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        {view === 'list' && t('user_management')}
        {view === 'detail' && t('user_details')}
        {view === 'verification' && t('user_verification')}
      </h1>
      
      {renderView()}
    </div>
  );
};

export default UserManagement;